/**
 * 전자계약 권한 정보 (SPEC-CONTRACT-VIEW-GRANT-001)
 *
 * 지점 소속 CS 엔지니어 명단이 코드 하드코딩에서 권한관리 화면 데이터로 옮겨지면서,
 * V3 목록·작성 화면은 "로그인 계정이 그 명단에 있는가"만 서버에서 받는다.
 * 소속(고객지원팀·장비품질팀) 판단은 화면이 기존 출처 그대로 한다 — 이 파일은 명단 포함 여부만 다룬다.
 *
 * 서버가 true/false 를 응답하면 그 값을 그대로 쓴다 — 권한관리 화면에서 바꾼 명단은 이 경로로만 반영된다.
 * 응답을 못 받으면(서버 배포 전·서버 롤백·네트워크 실패·응답 지연·형식이 다른 응답) 도입 전 하드코딩 명단으로 판단한다.
 * 그래서 실패해도 도입 전과 똑같이 동작하고, 이 화면 배포가 서버 배포 순서·롤백에 묶이지 않는다.
 */
import contractsApi from '@/contractsApi';

// 도입 전 V3 목록·작성 화면에 있던 명단 그대로(서버 코드 기본 명단과 같다). 응답을 못 받았을 때만 쓴다.
const LEGACY_CS_ENGINEER_USERNAMES = [
  '20190336', '20230040', '20210345', '20190082', '20220159', '20240180',
  '20190325', '20240053', '20190144', '20210353', '20220329', '20220022',
  '20210075', '20180112',
  '20260091', // 박성덕 강원지점 배치 (2026-09-11 배재환 본부장 요청)
];

function isLegacyCsEngineer() {
  try {
    const username = JSON.parse(localStorage.getItem('CompanyInfo'))?.accountInfo?.username;
    return LEGACY_CS_ENGINEER_USERNAMES.includes(username);
  } catch (error) {
    return false;
  }
}

export async function fetchContractViewCapabilities() {
  // 일시적 네트워크 실패에 대비해 한 번 더 시도한다.
  // 응답 없이 매달리면 작성 화면 탭이 끝내 그려지지 않으므로(탭이 이 응답을 기다린다) 시도마다 5초에서 끊는다.
  for (let attempt = 0; attempt < 2; attempt += 1) {
    try {
      const { data } = await contractsApi.get('/contract-view/capabilities', { timeout: 5000 });
      if (typeof data?.csEngineer === 'boolean') return { csEngineer: data.csEngineer };
    } catch (error) {
      // 다음 시도로 넘어간다
    }
  }
  return { csEngineer: isLegacyCsEngineer() };
}
